<script>
    import Auth from '../../app-front/mixins/Auth';

    export default {
        name: "RouteAccess",
        mixins:[Auth],
        methods: {
            redirectToLogin() {
                this.$router.push('/login').then(() => {}).catch(err => console.log(err));
            }
        },
        created(){
            this.checkAuth();
        },
        watch: {
            isUserLoggedIn: function() {
                if(!this.isUserLoggedIn) {
                    this.redirectToLogin();
                }
            }
        }
    }
</script>

<style scoped>

</style>
